import React, { useContext, useState } from 'react';

import Button from '@mui/material/Button';
import { SAVE_PRICE_DECK } from '../operations';
import SnackbarContext from '../../../../contexts/SnackbarContext';
import TextField from '@mui/material/TextField';
import { joinGqlErrorMessage } from '../../../../utils/gqlErrors';
import makeStyles from '@mui/styles/makeStyles';
import { useMutation } from '@apollo/client';

const useStyles = makeStyles((theme) => ({
  input: {
    width: '250px',
    margin: '10px',
  },
  button: {
    ...theme.palette.button,
    paddingTop: '8px',
    paddingBottom: '8px',
    margin: '10px 0 20px',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    flexDirection: 'column',
  },
}));

export const SavePriceDeck = ({ priceDeck, handleClose }) => {
  const classes = useStyles();
  const { setSnack } = useContext(SnackbarContext);
  const [name, setName] = useState('');
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  const [savePriceDeck] = useMutation(SAVE_PRICE_DECK, {
    variables: { priceDeck, name, notes },
    onCompleted: () => {
      setLoading(false);
      setSnack({
        open: true,
        severity: 'success',
        message: `Successfully saved price deck '${name}'!`,
      });
      handleClose();
    },
    onError: ({ graphQLErrors }) => {
      setLoading(false);
      setSnack({
        open: true,
        message: joinGqlErrorMessage(graphQLErrors),
        severity: 'error',
      });
    },
  });

  const requestSavePriceDeck = () => {
    setLoading(true);
    savePriceDeck();
  };

  return (
    <div className={classes.content}>
      <TextField
        className={classes.input}
        label="Price Deck Name"
        variant="filled"
        onChange={(e) => setName(e.target.value)}
      />
      <TextField
        className={classes.input}
        label="Notes"
        variant="filled"
        multiline
        rows={6}
        onChange={(e) => setNotes(e.target.value)}
      />
      <div className={classes.buttonWrapper}>
        <Button
          variant="contained"
          className={classes.button}
          onClick={requestSavePriceDeck}
          disabled={loading}
        >
          Save Price Deck
        </Button>
      </div>
    </div>
  );
};
